import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { fetchVacationRentalShop } from "../../actions/actions";
import {
  getVacationRentalShopSelectedListing,
} from "../../reducer";

import { withRouter } from "react-router";
import { ShopErrorCta } from "./component";
const mapStateToProps = (state: IStoreState) => {
  return {
    selectedListing: getVacationRentalShopSelectedListing(state),
  };
};

const mapDispatchToProps = {
  fetchVacationRentalShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ShopErrorCtaConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopErrorCta = withRouter(
    connector(ShopErrorCta)
);
